<template>
  <div class="BatteryFaultCount">
    <!-- <div
      class="BatteryFaultCount__title"
      v-show="list&&list.length"
    >
      <span class="BatteryFaultCount__item">
        <span
          class="BatteryFaultCount__text"
          v-for="(item, index) in tempList"
          :key="index"
        > <i :class="['iconfont',index<5?'el-icon-key':'el-icon-key',{BatteryFaultCount__text_primary: item<26,BatteryFaultCount__text_error: item>=26}]"></i> &nbsp;&nbsp;{{item}}<span style="margin-right:5px">° <span style="position:absolute;top:-3px;left:12px;transform:scale(0.8);" :style="{'color' : item < 26 ?'#00d3b8':'#d31515'}">{{index+1}}</span></span></span>
      </span>
    </div> -->
    <el-popover
      placement="left"
      width="60"
      trigger="click">
      <div class="select-type">
        <p v-for="item in selectType" :key="item" @click="onSelectClick(item)" :class="[activeType === item ? 'active': '']">{{ item }}</p>
      </div>
      <el-button slot="reference" class="select">
        {{ activeType }} <i class="el-icon-arrow-up el-icon--up"></i>
      </el-button>
    </el-popover>
    <div
      class="noDate"
      v-show="!list||!list.length"
    >
      <div>
        <img
          src="@/assets/img/home/noData.png"
          alt=""
        >
        <div>暂无电芯数据</div>
      </div>
    </div>
    <div
      class="BatteryFaultCount__content"
      v-show="list&&list.length"
    >
      <el-row :gutter="16">
        <el-col
          :span="6"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <div
            class="card card_primary"
          >
            <div class="card__box">
              <div
                class="card__title"
                :title='item.label'
              >
                {{ item.label }}
              </div>

              <div class="card__content">
                <div
                  class="card__battery"
                  :title="item.title"
                >
                  <i v-if="activeType == '电压'" class="iconfont icon-dianya batteryIcon" />
                  <i v-else class="el-icon-key batteryIcon" />
                </div>
                <div
                  class="card__right"
                  :title="item.title"
                >
                  <span class="card__label"></span>
                  <span class="card__text">{{item.value}} {{activeType == '电压' ?'V':'°C'}}</span>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    },
    list: {
      type: Array
    },
    tempList: {
      type: Array
    },
    batteryType: {
      type: String
    }
  },
  data() {
    return {
      activeType:'电压',
      selectType:['电压','电源'],
      iconList: [
        "icon-wenqu-",
        "icon-wenqu-4",
        "icon-wenqu-1",
        "icon-wenqu-2",
        "icon-wenqu-3",
        "icon-wenqu-5"
      ]
    };
  },
  computed:{
    type(){
        return this.$store.state.activeCls;
    },
    dataList(){
      if(this.activeType === '电压'){
        if(!this.list) return [];
        return this.list.map(item => ({ value:item.cellVoltage, label:`电芯${item.address + 1}号`,title:`电压${item.cellVoltage}V` }))
      }else{
        if(!this.tempList) return [];
        return this.tempList.map(item => ({ value:item.temperature, label:`电芯${item.address + 1}号`,title:`温度${item.cellVoltage}°C` }))
      }
    }
  },
  watch: {
    data: {
      handler(val) {
      },
      immediate: true,
      deep: true
    }
  },
  methods:{
    onSelectClick(item){
      this.activeType = item;
    }
  }
};
</script>


<style lang="scss" scoped>
.BatteryFaultCount {
  height: 333px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-top: 50px;
  position: relative;

  &__title {
    padding: 16px;
    word-break: keep-all;
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }

  &__content {
    @include scrollBar();
    overflow-y: auto;
    padding: 0 16px;
    height: calc(100% - 50px);
  }

  &__item {
    & + & {
      margin-left: 20px;
    }
  }

  &__label {
    font-size: 14px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  &__primary {
    padding: 2px 5px;
    margin-right: 5px;
    font-size: 12px;
    background-color: rgb(225, 253, 220);
    border-radius: 10px;
    color: rgb(67, 224, 132);
  }
  &__error {
    padding: 2px 5px;
    margin-right: 5px;
    font-size: 12px;
    background-color: rgb(238, 209, 209);
    border-radius: 10px;
    color: rgb(219, 100, 100);
  }
  &__text {
    font-size: 14px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 3px;
    display: inline-block;
    font-weight: bold;
    position: relative;
    &_primary {
        margin-right: 2px;
      color: rgba(0, 211, 184, 1);
    }

    &_error {
        margin-right: 2px;
      color: rgba(211, 21, 21, 1);
    }
  }
}
.noDate {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    // img {
    //   border: 1px dashed black;
    // }
    div {
      text-align: center;
      margin-top: 15px;
    }
  }
}
.select-type{
  text-align: center;
  >p{
    padding: 2px 0;
    cursor: pointer;
  }
  .active{
    color: rgba(0, 211, 184, 1);
  }
}
.select{
  position: absolute;
  right: 10px;
  top: 10px;
  border-radius: 26px;
  width: 80px;
  padding: 6px 14px;

}
.card {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(239, 239, 239, 1);
  box-shadow: 0px 2px 4px 0px rgba(80, 80, 80, 0.07);
  &__box {
    word-break: keep-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 8px;
  }
  &_primary {
    .card__tag {
      // background: rgba(220, 255, 251, 1);
      color: rgba(0, 211, 184, 1);

    }

    .card__battery {
      background: rgba(29, 236, 209, 1);
    }
  }

  &_error {
    .card__tag {
      // background: rgba(255, 206, 201, 1);
      color: rgba(246, 95, 79, 1);
    }

    .card__battery {
      background: rgba(246, 95, 79, 1);
    }
  }

  &__title {
    margin-top: 5px;
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(47, 61, 67, 1);
    line-height: 16px;
    word-break: keep-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__tag {
    // padding: 3px 6px;
    color: #fff;
    font-size: 10px;
    margin-left: 5px;
    user-select: none;
  }

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__battery {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 10px 1px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1px;
    span {
      color: #fff;
      font-size: 10px;
    }
    // i {
    //   position: absolute;
    //   top: 50%;
    //   left: 50%;
    //   transform: translate(-50%, -50%);
    //   font-size: 1.3vw;
    //   color: #fff;
    // }
  }

  &__right {
    flex: 1;
    word-break: keep-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 16px;
  }

  &__label {
    font-size: 13px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 16px;
    margin-right: 5px;

    // &::after {
    //   content: ":";
    // }
  }

  &__text {
    font-size: 12px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 16px;
  }
}
// .card:hover {
//   // transform: scale(1.05);
// }
.el-icon-warning {
  color: rgb(197, 48, 48);
  font-size: 14px;
}
.batteryIcon {
  background-color: #fff;
  color: #999;
}
</style>
